import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AppErrorBoundary, installCrashGuards } from "@/components/AppErrorBoundary";

installCrashGuards();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
);

// Register the PWA service worker and pick up new versions automatically (no stale/black screens).
if ("serviceWorker" in navigator) {
  let reloaded = false;
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    const playing = [...document.querySelectorAll("audio,video")].some((m) => !m.paused);
    if (!hadController || reloaded || playing) return;
    reloaded = true;
    window.location.reload();
  });
  navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((reg) => {
    const check = () => reg.update().catch(() => {});
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
    setInterval(check, 30 * 60 * 1000);
  }).catch(() => {});
}

// Capture the install prompt as early as possible so the "Install App" menu can trigger it.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__bipEvent = e;
  window.dispatchEvent(new Event("bip-ready"));
});
window.addEventListener("appinstalled", () => { window.__bipEvent = null; });
